if (!customElements.get('header-drawer-toggle')) {
  class HeaderDrawerToggle extends HTMLElement {
    constructor() {
      super();

      this.handleClickRef = this.handleClick.bind(this);
    }

    handleClick(event) {
      event.preventDefault();
      this.classList.toggle('is-open');
      document.dispatchEvent(new CustomEvent('exo:toggle-header-drawer'));
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClickRef);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClickRef);
    }
  }

  customElements.define('header-drawer-toggle', HeaderDrawerToggle);
}
